import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { DynaDocsModelRepository } from '@/store/dyna-docs-model-state/dyna-docs-model-state.repository';

interface IGetDynaDocsModelUpdateDrawerObjectProps {
  store: DynaDocsModelRepository;
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getDynaDocsModelUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IGetDynaDocsModelUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.dynaDocsModels.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: { formObject },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.dynaDocsModels.update.update',
        onClick: () => action?.(),
      },
      {
        label: 'settings.dynaDocsModels.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
